import React from "react";
import { Link } from "react-router-dom";
import {
  FaUser,
  FaBuilding,
  FaRocket,
  FaClock,
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp,
  FaArrowRight,
  FaCheckCircle,
  FaBullseye,
} from "react-icons/fa";
import subscriptionHeroImage from "../Assets/images/innerbranding.png";
import SubscriptionSection from "./SubscriptionSection";
import "./SubscriptionPage.css";

const SubscriptionPage = () => {
  return (
    <div className="staffline-subscription-page">

      {/* ===== HERO SECTION ===== */}
      <section
        className="staffline-subscription-hero"
        style={{ backgroundImage: `url(${subscriptionHeroImage})` }}
      >
        <div className="staffline-subscription-hero-overlay"></div>

        <div className="container staffline-subscription-hero-content">
          <span className="staffline-subscription-hero-tag">
            <FaRocket /> Subscriptions Opening Soon
          </span>

          <h1 className="staffline-subscription-hero-title">
            Subscribe to <span>StaffLine Transport</span>
          </h1>

          <p className="staffline-subscription-hero-subtitle">
            Our subscription portal is being built to serve both{" "}
            <strong>individuals</strong> and{" "}
            <strong>corporate companies</strong>. In the meantime, contact us
            directly to get started.
          </p>

          <div className="staffline-subscription-hero-actions">
            <Link
              to="/contact-us"
              className="staffline-subscription-hero-btn-primary"
            >
              <FaEnvelope /> Contact Us to Subscribe
            </Link>
            <Link
              to="/routes"
              className="staffline-subscription-hero-btn-secondary"
            >
              View Routes <FaArrowRight />
            </Link>
          </div>

          <div className="staffline-subscription-hero-stats">
            <div className="staffline-subscription-hero-stat">
              <FaClock />
              <div>
                <strong>Mon – Fri</strong>
                <span>Service Days</span>
              </div>
            </div>
            <div className="staffline-subscription-hero-stat">
              <FaCheckCircle />
              <div>
                <strong>800 GHS</strong>
                <span>Flat Monthly Fee</span>
              </div>
            </div>
            <div className="staffline-subscription-hero-stat">
              <FaBullseye />
              <div>
                <strong>24+</strong>
                <span>Routes Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SUBSCRIPTION SECTION (Coming Soon Message) ===== */}
      <SubscriptionSection />

    </div>
  );
};

export default SubscriptionPage;